<!--============ Banner Start ============-->
<div id="main-wrapper">
   <div class="site-wrapper-reveal">
      <div class="position-relative w-100">
         <div class="d-flex align-items-center w-100">
            <!-- "> md" -->
            <img src="../../../assets/images/banners/blog-bannernew.png"
               class="img img-responsive w-100 h-100 d-none d-md-block" width="100%" alt="banner new" />
            <!-- "<= md" -->
            <img src="../../../assets/images/banners/blogs-mobilebanner.png"
               class="img img-responsive d-block d-md-none" width="100%" alt="banner mobilebanner" />
            <!-- <img src="../../../assets/images/banners/mitbannername.png"
               alt="Banner-mit" class="img-responsive w-100 h-100"> -->
            <div class="position-absolute w-100 home-banner">
               <div class="row h-100 w-100">
                  <div class="col-8 col-md-4 col-sm-6 banner-section">
                     <div class="align-items-center banner-content-title  global_title global_banner_title" role="heading" aria-level="1">
                        <span>Blogs</span>
                     </div>
                     <div class="global_sub_title global_banner_subtitle mt-3">
                        <span>Explore the home to our best blog posts on topics from AI, security to innovation from
                           leaders across industries and functions.</span>
                     </div>
                  </div>
               </div>
            </div>
         </div>
      </div>
      <!-- <div class=" banner-subsection col">
         <h5>Trusted by Global Technology companies</h5>
         </div> -->
   </div>
</div>
<!--============ Banner End ============-->



<div id="main-wrapper">
   <div class="site-wrapper-reveal">
      <div class="projects-wrapper section-space--ptb_90 projects-masonary-wrapper">
         <div class="container">
            <!--====== Blogs Proud Projects Start ======-->
            <div class="row">
               <div class="col-lg-12">
                  <div class="section-title-wrap text-center section-space--mb_40">
                     <div class="casestudies_heading text-black global_section_header" role="heading" aria-level="1"><b>Blogs
                        </b>
                     </div>
                  </div>
                  <div class="messonry-button text-center  section-space--mb_60">

                     <div class="filter-button-container">
                        <button (click)="filter('all')" [ngClass]="{ 'active': selectedFilter === 'all' }"
                           class="filter-button1"><span class="filter-text">All</span></button>

                        <button (click)="filter('Technology')" [ngClass]="{ 'active': selectedFilter === 'Technology' }"
                           class="filter-button1"><span class="filter-text">Technology</span></button>

                        <button (click)="filter('consulting_staffing')"
                           [ngClass]="{ 'active': selectedFilter === 'consulting_staffing' }" class="filter-button1 ">
                           <span class="filter-text">IT Consulting and Staffing</span></button>

                        <button (click)="filter('digital_marketing')"
                           [ngClass]="{ 'active': selectedFilter === 'digital_marketing' }" class="filter-button1 ">
                           <span class="filter-text">Digital Marketing</span></button>
                     </div>

                  </div>


               </div>
            </div>
            <!--====== Blogs Proud Projects End ======-->



            <!--====== Blogs Cards  Start ======-->

            <!-- Display Filtered Blogs -->
            <div class="projects-case-wrap">
               <div class="row">
                  <!-- Iterate through the filtered blogs -->
                  <div *ngFor="let blog of filteredBlogs" class="col-lg-4 col-md-6">
                     <!-- Blog Card -->
                     <div class="projects-wrap style-01">
                        <div class="projects-image-box">
                           <!-- Blog Image -->
                           <div class="projects-image">
                              <img [src]="blog.image" alt="Blog image showing cloud disaster recovery strategies with an illustration of disaster recovery plan"  class="w-100" />
                           </div>
                           <!-- Blog Content -->
                           <div class="content">
                              <h4 class="heading " >{{ blog.title }}</h4>
                              <div  class="post-categories">{{ blog.category }} </div>
                              <div class="text">{{ blog.description }}</div>
                              <div class="box-projects-arrow">
                                 <span class="button-text">
                                    <a class="blog_anchorviewmore" [href]="blog.link">View More</a>
                                 </span>
                                 <i class="fa fa-long-arrow-right ml-1" style="margin-left: 10px;" role="presentation"></i>
                              </div>
                           </div>
                        </div>
                     </div>
                  </div>
               </div>
            </div>
            <!--====== Blogs Cards  End ======-->
         </div>
      </div>
   </div>
</div>